(function AdzukiSort($, Adzuki)
{
	'use strict';

	const component = {
		emits: ['updated', 'set-default'],
		props: {
			sortOptions: {
				type    : Array,
				required: true,
				default : {
					key        : '',
					label      : '',
					description: ''
				}
			},
			// MEDIA-332: the current sort, when the host owns it (Trip Summary keeps one
			// per tab). Left out, the control keeps its own, as Maxx Media's always has.
			sortByKey: {
				type    : String,
				required: false,
				default : null,
			},
			sortByDirection: {
				type    : String,
				required: false,
				default : null,
			},
			// TS-390, folded in from Trip Summary's own sort (MEDIA-332): the agent's
			// profile default, so the menu can mark it, and whether to offer "Set as my
			// default" (the host decides where a default applies)
			defaultKey: {
				type    : String,
				required: false,
				default : null,
			},
			defaultDirection: {
				type    : String,
				required: false,
				default : null,
			},
			showDefaultControl: {
				type    : Boolean,
				required: false,
				default : false,
			},
			defaultControlLabel: {
				type    : String,
				required: false,
				default : 'Set as my default',
			},
			defaultCurrentLabel: {
				type    : String,
				required: false,
				default : 'This is your default sort.',
			},
		},
		data() {
			return {
				sortBy: {
					key      : this.sortByKey || '',
					direction: this.sortByDirection || 'asc',
				}
			};
		},
		computed: {
			currentIsDefault() {
				return Boolean(this.defaultKey)
					&& this.sortBy.key === this.defaultKey
					&& this.sortBy.direction === this.defaultDirection;
			},
		},
		watch: {
			sortByKey(key) {
				// a new object, never a mutation: the host may hold the emitted one
				if (key !== null) {
					this.sortBy = {
						key      : key,
						direction: this.sortBy.direction,
					};
				}
			},
			sortByDirection(direction) {
				if (direction !== null) {
					this.sortBy = {
						key      : this.sortBy.key,
						direction: direction,
					};
				}
			},
		},
		methods: {
			activeOption(key, direction) {
				return this.sortBy.key === key && this.sortBy.direction === direction;
			},
			changeSort(key, direction) {
				if (this.sortBy.key === key && this.sortBy.direction === direction) {
					return;
				}

				this.sortBy = {
					key      : key,
					direction: direction,
				};

				this.$emit('updated', {
					key      : key,
					direction: direction,
				});
			},
			// the direction the agent's default uses for this key, or null
			defaultDirectionFor(key) {
				return (this.defaultKey === key ? this.defaultDirection : null);
			},
			setDefault() {
				this.$emit('set-default', {
					key      : this.sortBy.key,
					direction: this.sortBy.direction,
				});
			},
		},
		template: `
			<div id="adzuki-sort-container" class="mx-2">
			  <button
				  class="dropdown-toggle adzuki-sort-toggle btn btn-link"
				  type="button"
				  href="#"
				  data-bs-toggle="dropdown"
				  data-bs-auto-close="outside"
				  aria-expanded="false"
			  >
					Sort...
			  </button>
			  <ul class="adzuki-sort dropdown-menu dropdown-menu-end">
				<li v-for="option in sortOptions" :key="option.key">
				  <div class="row align-items-center">
					<div class="col-8">
					  <h5>{{ option.label }}</h5>
					  <span v-if="defaultDirectionFor(option.key)" class="adzuki-sort-default-badge">Default, {{ defaultDirectionFor(option.key) === 'asc' ? 'ascending' : 'descending' }}</span>
					  <p v-if="option.description">{{ option.description }}</p>
					</div>
					<div class="col-4 text-end">
					  <a href="#"
						 type="button"
						 class="btn btn-sm btn-outline-primary me-1 mt-1"
						 :class="{ 'active': activeOption(option.key, 'asc') }"
						 :aria-label="option.label + ', ascending'"
						 @click.prevent="changeSort(option.key, 'asc')">
						 <i class="fas fa-chevron-up"></i>
					  </a>
					  <a
						  type="button"
						  class="btn btn-sm btn-outline-primary mt-1"
						  :class="{ 'active': activeOption(option.key, 'desc') }"
						  :aria-label="option.label + ', descending'"
						  href="#"
						  @click.prevent="changeSort(option.key, 'desc')">
						  <i class="fas fa-chevron-down"></i>
					  </a>
					</div>
				  </div>
				</li>
				<li v-if="showDefaultControl" class="adzuki-sort-default-control">
				  <p v-if="currentIsDefault" class="text-muted mb-0">{{ defaultCurrentLabel }}</p>
				  <button v-else type="button" class="btn btn-sm btn-link p-0" @click="setDefault">{{ defaultControlLabel }}</button>
				</li>
			  </ul>
			</div>
		`,
	};

	Adzuki.VueComponents.AdzukiSort = component;
}(jQuery, window.Adzuki || {}));
